import api from './api';
import { Grab, CreateGrabRequest, UpdateGrabRequest } from '../types';

// Listen/Picker brauchen keine Geometrie – ohne Polygone ist die Antwort um ein Vielfaches
// kleiner. Nur wer sie wirklich rendert (Minikarte auf der Grab-Detailseite), fordert sie an.
type GrabListOptions = { includePolygon?: boolean };

export const grabService = {
  getAll: async (opts?: GrabListOptions): Promise<Grab[]> => {
    const response = await api.get(`/graeber?includePolygon=${opts?.includePolygon === true}`);
    return response.data;
  },
  getByFriedhof: async (friedhofId: number, opts?: GrabListOptions): Promise<Grab[]> => {
    const response = await api.get(`/graeber?friedhofId=${friedhofId}&includePolygon=${opts?.includePolygon === true}`);
    return response.data;
  },
  getById: async (id: number): Promise<Grab> => {
    const response = await api.get(`/graeber/${id}`);
    return response.data;
  },
  create: async (data: CreateGrabRequest): Promise<Grab> => {
    const response = await api.post('/graeber', data);
    return response.data;
  },
  update: async (id: number, data: UpdateGrabRequest): Promise<Grab> => {
    const response = await api.put(`/graeber/${id}`, data);
    return response.data;
  },
  delete: async (id: number): Promise<void> => {
    await api.delete(`/graeber/${id}`);
  }
};

export default grabService;
